import React from "react";
import PageWrapper from "./PageWrapper";

export default function AccessDenied({ message = "Access denied." }) {
  return (
    <PageWrapper>
      <p className="text-red-600 py-8 text-center">{message}</p>
    </PageWrapper>
  );
}
